module.exports = __webpack_public_path__ + "img/NKcropwise01.3943418b.png";